import { useState } from 'react';
import { pushLeadEvent } from './leadActivity';

const CHANNELS = [
  { id: 'whatsapp', label: 'WhatsApp', icon: '💬', color: '#25d366' },
  { id: 'sms', label: 'SMS', icon: '📱', color: '#1565c0' },
  { id: 'email', label: 'Email', icon: '📧', color: '#e65100' },
];

const TEMPLATES = {
  whatsapp: [
    { id: 'w1', name: 'Follow up', text: 'Hi {name}, following up on your enquiry. Are you still interested?' },
    { id: 'w2', name: 'Appointment', text: 'Hi {name}, your appointment is confirmed for {date}. See you soon!' },
    { id: 'w3', name: 'Offer', text: 'Hi {name}, special offer just for you! Contact us today.' },
  ],
  sms: [
    { id: 's1', name: 'Follow up', text: 'Hi {name}, following up on your enquiry. Please call us back.' },
    { id: 's2', name: 'Reminder', text: 'Reminder: Your appointment is tomorrow. Reply CONFIRM or CANCEL.' },
  ],
  email: [
    { id: 'e1', name: 'Introduction', subject: 'Thank you for your interest', text: 'Dear {name},\n\nThank you for your interest. We would love to help you.\n\nBest regards,\nTeam' },
    { id: 'e2', name: 'Follow up', subject: 'Following up on your enquiry', text: 'Dear {name},\n\nWe are following up on your recent enquiry. Please let us know if you have any questions.\n\nBest regards,\nTeam' },
  ],
};

const SMS_SEGMENT = 160;
const digits = (p) => String(p || '').replace(/[^0-9]/g, '');
const validEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || '').trim());
const openLink = (href, newTab) => {
  const a = document.createElement('a');
  a.href = href;
  if (newTab) { a.target = '_blank'; a.rel = 'noopener'; }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const inp = { width: '100%', padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none', marginBottom: 10 };
const lbl = { fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', marginBottom: 6, display: 'block' };

export function LeadMultiChannel({ lead, onClose }) {
  const [channel, setChannel] = useState('whatsapp');
  const [mode, setMode] = useState('mobile');
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [email, setEmail] = useState((lead && lead.email) || '');
  const [done, setDone] = useState('');
  const [copied, setCopied] = useState(false);

  const phone = digits(lead && lead.phone);
  const fullPhone = phone.length === 10 ? '91' + phone : phone;
  const apiMode = channel === 'whatsapp' && mode === 'api';
  const canSend = !!message.trim() && !apiMode && (channel === 'email' ? validEmail(email) : !!phone);
  const current = CHANNELS.find(c => c.id === channel);
  const sendLabel = channel === 'whatsapp' ? 'Open WhatsApp' : channel === 'sms' ? 'Open SMS app' : 'Open email app';

  const fillTemplate = (tpl) => {
    setMessage(tpl.text
      .replace(/\{name\}/g, (lead && lead.name) || 'Customer')
      .replace(/\{date\}/g, new Date().toLocaleDateString('en-IN')));
    if (channel === 'email' && tpl.subject && !subject) setSubject(tpl.subject);
  };

  const send = () => {
    if (!canSend) return;
    let note = '';
    if (channel === 'whatsapp') {
      openLink('https://wa.me/' + fullPhone + '?text=' + encodeURIComponent(message), true);
      note = 'WhatsApp opened with your message. Press send there to deliver it.';
    } else if (channel === 'sms') {
      openLink('sms:' + phone + '?body=' + encodeURIComponent(message), false);
      note = 'Your messaging app opened with this SMS. Press send there to deliver it.';
    } else {
      openLink('mailto:' + email.trim() + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(message), false);
      note = 'Your email app opened with this draft. Press send there to deliver it.';
    }
    pushLeadEvent({ phone: lead && lead.phone, name: lead && lead.name, type: 'message', text: current.label + ' message prepared and opened for sending' });
    setDone(note);
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(message); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch (e) {}
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1500, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 24, width: 460, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 800, color: '#1a1a2e' }}>📤 Send Message</div>
            <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>{lead && lead.name} · {lead && lead.phone}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#aaa' }}>✕</button>
        </div>

        {done ? (
          <div>
            <div style={{ background: '#e8f5e9', color: '#2e7d32', borderRadius: 10, padding: '14px 16px', fontSize: 13, fontWeight: 600, lineHeight: 1.5 }}>✅ {done}</div>
            <button onClick={onClose} style={{ width: '100%', marginTop: 14, padding: '10px 0', background: '#25d366', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Close</button>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              {CHANNELS.map(c => (
                <button key={c.id} onClick={() => { setChannel(c.id); setMessage(''); }} style={{
                  flex: 1, padding: '10px 0', border: `2px solid ${channel === c.id ? c.color : '#eee'}`,
                  borderRadius: 10, background: channel === c.id ? c.color + '15' : '#fff',
                  color: channel === c.id ? c.color : '#888', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                }}>{c.icon} {c.label}</button>
              ))}
            </div>

            {channel === 'whatsapp' && (
              <div style={{ marginBottom: 14 }}>
                <span style={lbl}>Send via</span>
                <div style={{ display: 'flex', gap: 6 }}>
                  {[['mobile', 'My WhatsApp', ''], ['api', 'Business API', 'Preview']].map(([id, label, tag]) => (
                    <button key={id} onClick={() => setMode(id)} style={{
                      flex: 1, padding: '8px 6px', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
                      border: `1.5px solid ${mode === id ? '#25d366' : '#e5e7eb'}`, background: mode === id ? '#f0faf5' : '#fff', color: mode === id ? '#075e54' : '#777',
                    }}>
                      {label}
                      {tag && <span style={{ marginLeft: 6, fontSize: 9, background: '#fff3e0', color: '#e65100', padding: '1px 6px', borderRadius: 8 }}>{tag}</span>}
                    </button>
                  ))}
                </div>
                {apiMode && (
                  <div style={{ marginTop: 8, fontSize: 11, color: '#e65100', background: '#fff8e1', borderRadius: 8, padding: '8px 10px' }}>
                    Sending through the Business API needs backend integration. Use "My WhatsApp" for now.
                  </div>
                )}
              </div>
            )}

            <div style={{ marginBottom: 12 }}>
              <span style={lbl}>Quick Templates</span>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {(TEMPLATES[channel] || []).map(t => (
                  <button key={t.id} onClick={() => fillTemplate(t)} style={{
                    padding: '5px 12px', fontSize: 11, fontWeight: 600, border: '1px solid #e0e0e0',
                    borderRadius: 20, background: '#fff', color: '#555', cursor: 'pointer', fontFamily: 'inherit',
                  }}>{t.name}</button>
                ))}
              </div>
            </div>

            {channel !== 'email' && !phone && (
              <div style={{ fontSize: 11, color: '#c62828', marginBottom: 10 }}>This lead has no phone number.</div>
            )}

            {channel === 'email' && (
              <>
                <label style={lbl}>To</label>
                <input style={inp} type="email" placeholder="customer@example.com" value={email} onChange={e => setEmail(e.target.value)} />
                <label style={lbl}>Subject</label>
                <input style={inp} placeholder="Email subject" value={subject} onChange={e => setSubject(e.target.value)} />
              </>
            )}

            <label style={lbl}>Message</label>
            <textarea style={{ ...inp, minHeight: 100, resize: 'vertical', marginBottom: 4 }}
              placeholder={`Type your ${channel} message...`} value={message} onChange={e => setMessage(e.target.value)} />
            {channel === 'sms' && message.length > 0 && (
              <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>{message.length} characters · {Math.max(1, Math.ceil(message.length / SMS_SEGMENT))} SMS</div>
            )}

            <div style={{ fontSize: 11, color: '#aaa', margin: '8px 0 14px', lineHeight: 1.5 }}>
              {channel === 'whatsapp' && mode === 'mobile' && '💬 Opens WhatsApp with this message ready to send.'}
              {channel === 'sms' && '📱 Opens your device messaging app. Sending SMS from the server needs backend integration (preview).'}
              {channel === 'email' && '📧 Opens your email app with this draft. Sending email from the server needs backend integration (preview).'}
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={onClose} style={{ flex: 1, padding: '10px 0', background: '#f0f0f0', color: '#333', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
              {message.trim() && (
                <button onClick={copy} style={{ flex: 1, padding: '10px 0', background: '#fff', color: '#075e54', border: '1.5px solid #cdeedd', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>{copied ? 'Copied' : 'Copy'}</button>
              )}
              <button onClick={send} disabled={!canSend} style={{ flex: 2, padding: '10px 0', background: canSend ? '#25d366' : '#ccc', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: canSend ? 'pointer' : 'not-allowed', fontFamily: 'inherit' }}>{sendLabel}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
